export default __webpack_public_path__ + "static/media/customers.9345a389.svg";